class UserAuthService {
  private userValidatedToken?: string;

  isUserValidated(): boolean {
    return !!this.userValidatedToken;
  }

  getValidatedUserToken(): string | undefined {
    return this.userValidatedToken;
  }

  setValidateUserToken(token?: string): void {
    this.userValidatedToken = token;
  }
}

const userAuthService = new UserAuthService();
export { userAuthService };
